//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MoreInfoButton',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    cardClass: { type: String, default: '' },
  },
  data() {
    let mobileQuery;
    let tabletQuery;
    if (process.client) {
      mobileQuery = window.matchMedia('(max-width: 768px)');
      tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1200px)');
    }
    return {
      isOpen: false,
      mobileQuery,
      tabletQuery,
      mobileStyles: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      isMobile: mobileQuery?.matches || false, // Initialize with the current match status
      isTablet: tabletQuery?.matches || false, // Initialize with the current match status
    };
  },
  mounted() {
    this.mobileQuery.addListener(() => {
      this.isMobile = this.mobileQuery.matches;
    });

    this.tabletQuery.addListener(() => {
      this.isTablet = this.tabletQuery.matches;
    });
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('cardOpen');
    },
    close() {
      this.isOpen = false;
    },
  },
};
